import { ApplicationType } from './constants/app';
import { TLink, TShopMenu } from '../entities/content';
import { isShopAvailableAndLogoLinksToShop } from './helper/shop-helper';
import { GlobalDataLayerService } from '../services/analytics/global-data-layer-service';
import { ClickElementTypes, EventActions } from './constants';

export function getLogoLink(locale: string, app: ApplicationType, crest: TLink, shop: TShopMenu | null) {
  return shop && isShopAvailableAndLogoLinksToShop(locale, app, shop) ? shop.link : crest.link;
}

export function getLogoAriaLabel(locale: string, app: ApplicationType, shop: TShopMenu | null) {
  return isShopAvailableAndLogoLinksToShop(locale, app, shop) ? 'Porsche Shop Homepage' : 'Porsche.com Homepage';
}

export function sendLogoDataLayerEvent(crest: TLink): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(EventActions.CREST_CLICK, {
    componentClick: {
      clickElementId: crest.id,
      clickElementName: crest.text,
      clickElementType: ClickElementTypes.Link,
      targetUrl: crest.link
    }
  });
}
